/**
 * DiskCapacityContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled disk capacity container.
 */
const DiskCapacityContainer = styled.div<React.CSSProperties>`
  position: relative;
  left: ${20 * Screen.widthRatio}px;
  top: ${270 * Screen.widthRatio}px;
  height: ${862 * Screen.widthRatio}px;
  width: ${1700 * Screen.widthRatio}px;
`;

export default withOpacity(DiskCapacityContainer);
